import styled from '@emotion/styled'

export const Button = styled.button`
  line-height: 1;
  width: 540px;
  height: 52px;
  background-image: linear-gradient(#004c94, #043871);
  color: #ffffff;
  font-size: 24px;
  border: 0;
  outline: 0;
  cursor: pointer;
  border-radius: 5px;

  :hover {
    background: #004c94;
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.4;

    :hover {
      background-image: linear-gradient(#004c94, #043871);
    }
  }
`

export const Input = styled.input`
  width: 544px;
  height: 50px;
  border: 1px solid #bfbfbf;
  border-radius: 5px;
  outline: 0;
  font-size: 20px;
  padding: 0 15px;
  background: #ffffff;

  ::-webkit-input-placeholder {
    color: #999999;
  }
`

export const LinkButton = styled.span`
  cursor: pointer;
  color: #ee3a34;
  font-size: 16px;

  :hover {
    color: rgba(238, 58, 52, 0.8);
  }
`

export const GhostButton = styled.button`
  width: 94px;
  height: 36px;
  border: 1px solid #27527f;
  background: #ffffff;
  color: #27527f;
  font-size: 18px;
  outline: 0;
  cursor: pointer;
  border-radius: 5px;

  :hover {
    color: rgba(39, 82, 127, 0.8);
    border-color: rgba(39, 82, 127, 0.8);
  }
`

export const CommonWrapper = styled.div`
  max-width: 1391px;
  margin: 0 auto;
`
